import { useTheme } from '@mui/material';

import { cssColorHexToRgbA } from '~/utils/helpers/css';

export const useSxStyles = () => {
  const SystemColor = '#00F';
  const theme = useTheme();

  return {
    dataGrid: {
      '.MuiDataGrid-row.system-entry': {
        backgroundColor: cssColorHexToRgbA(SystemColor, 0.03),

        '&.Mui-hovered': {
          backgroundColor: cssColorHexToRgbA(SystemColor, 0.06),
        },
      },
    },
    panelContent: {
      padding: theme.spacing(2),
      backgroundColor: '#fafafa',
      boxShadow: `${theme.shadows[1].replaceAll('),', ') inset,')} inset`,
    },
  };
};
